/**
 * Empty = same origin (prod embed, or Vite `/api` proxy).
 * `pnpm dev` → proxy to localhost:8081; `pnpm dev:remote` → proxy to
 * open-backlog.thelionparcel.com (keeps uploads same-origin; avoids CF 403).
 * Override only if you must call the API cross-origin: VITE_API_BASE_URL.
 */
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? "").replace(/\/$/, "");

export const APP_NAME = "Open Backlog";

export const ACCESS_TOKEN_KEY = "lio_quest_access_token";
export const REFRESH_TOKEN_KEY = "lio_quest_refresh_token";

/**
 * When true, FE serves in-memory mock data (no backend / Nexus).
 * Enable with `VITE_MOCK_API=true` or `pnpm dev:mock`.
 */
export const MOCK_API =
  import.meta.env.VITE_MOCK_API === "true" ||
  import.meta.env.VITE_MOCK_API === "1";

/** Directorates available on the initiative intake form (handover list). */
export const DIRECTORATES = [
  "Commercial",
  "Operations",
  "Finance",
  "Technology",
  "Product",
  "Marketing",
  "Customer Experience",
  "Human Capital",
  "Corporate Strategy",
  "Legal & Compliance",
] as const;

/** Strategic pillars — one required per request (stored as project_objective). */
export const STRATEGIC_PILLARS = [
  { key: "Revenue", label: "Revenue", help: "Grows sales or new income" },
  { key: "Customer Experience", label: "Customer Experience", help: "Makes it easier or better for customers" },
  { key: "International Expansion", label: "International Expansion", help: "Supports new countries or cross-border" },
  { key: "Operational Excellence", label: "Operational Excellence", help: "Faster, more reliable operations" },
  { key: "Compliance", label: "Compliance", help: "Legal, regulatory or audit needs" },
  { key: "Cost Efficiency", label: "Cost Efficiency", help: "Reduces cost or waste" },
] as const;

export type StrategicPillar = (typeof STRATEGIC_PILLARS)[number]["key"];

/** @deprecated Use STRATEGIC_PILLARS — kept as label list for filters/chips. */
export const PROJECT_OBJECTIVES = STRATEGIC_PILLARS.map((p) => p.key);

export type ProjectObjective = StrategicPillar;

/**
 * Jira boards that receive the Project issue when creating after Proceed.
 * Chosen on Create Jira Project; server falls back to [jira].project_key when empty.
 */
export const JIRA_PROJECT_KEYS = ["GENESIS", "CUST", "WEBLP", "CORB"] as const;

export type JiraProjectKey = (typeof JIRA_PROJECT_KEYS)[number];

/** Display labels for the Create Jira Project board select. */
export const JIRA_PROJECT_LABELS: Record<JiraProjectKey, string> = {
  GENESIS: "Genesis",
  CUST: "Customer App Team",
  WEBLP: "Lion Parcel Web",
  CORB: "Corporate Business",
};
